<div class="page-content">
    <p-panel header="Organizations" class="no-x-padding">
        <div class="hcol-flex">
            <div class="hcol-grow">
                <app-organization-crud></app-organization-crud>
            </div>
            <div [style.width]="'8rem'">
                <p-panel header="Overview" class="title-center">
                    <app-customer-organizations-numbers></app-customer-organizations-numbers>
                </p-panel>
            </div>
        </div>
    </p-panel>
</div>
